var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content-area__content" },
    [
      _c("vue-title", {
        attrs: {
          title: _vm.$t("identityProvider:changeUsername:title", null, [
            _vm.$t("shared:fields:username")
          ])
        }
      }),
      _vm._v(" "),
      _c(
        "h1",
        {
          staticClass: "section-title",
          attrs: { "data-test-element": "changeusername-title" }
        },
        [
          _vm._v(
            _vm._s(
              _vm.$t("identityProvider:changeUsername:title", null, [
                _vm.$t("shared:fields:username")
              ])
            )
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        {
          ref: "form",
          attrs: { action: "authentication/changeusername" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.validateBeforeSubmit.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.model.errorMessage && !_vm.errors.any(),
                  expression: "model.errorMessage && !errors.any()"
                }
              ],
              staticClass:
                "validation-summary-errors alert alert-danger fade show",
              attrs: { role: "alert", "data-valmsg-summary": "true" }
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  attrs: { "data-test-element": "changeusername-errormessage" }
                },
                [_vm._v(_vm._s(_vm.model.errorMessage))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.any() || _vm.hasError,
                  expression: "errors.any() || hasError"
                }
              ],
              staticClass:
                "validation-summary-errors alert alert-danger fade show",
              attrs: { role: "alert", "data-valmsg-summary": "true" }
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
              _vm._v(" "),
              _vm.errors.has(".")
                ? _c("span", [_vm._v(_vm._s(_vm.errors.first(".")))])
                : _c(
                    "span",
                    {
                      staticClass: "alert-message",
                      attrs: { "data-test-element": "alert-message" }
                    },
                    [_vm._v(_vm._s(_vm.$t("validation:summary")))]
                  )
            ]
          ),
          _vm._v(" "),
          _c("fieldset", { staticClass: "panel" }, [
            _c(
              "div",
              {
                staticClass: "panel-message",
                attrs: {
                  "data-test-element": "changeusername-instructionmessage"
                }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t(
                        "identityProvider:changeUsername:instructions",
                        null,
                        [_vm.$t("shared:fields:username").toLowerCase()]
                      )
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "label",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "label",
                      attrs: {
                        "data-test-element": "changeusername-label-newusername"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "identityProvider:changeUsername:newUsername",
                            null,
                            [_vm.$t("shared:fields:username")]
                          )
                        )
                      ),
                      _c("contextual-help-component", {
                        attrs: {
                          text: _vm.model.contextualHelp,
                          "data-test-element": "changeusername-contextualHelp",
                          tabindex: "0"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "control-with-help-offset" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.newUsername,
                          expression: "model.newUsername"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "control -with-help",
                      class: {
                        "input-validation-error": _vm.hasErrorOn("NewUsername")
                      },
                      attrs: {
                        name: "NewUsername",
                        id: "newusername",
                        "data-test-element": "changeusername-newusername",
                        "data-vv-as": _vm.$t(
                          "identityProvider:changeUsername:newUsername",
                          null,
                          [_vm.$t("shared:fields:username")]
                        ),
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.model.newUsername },
                      on: {
                        change: _vm.onNewUserNameChange,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.model,
                            "newUsername",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasErrorOn("NewUsername"),
                      expression: "hasErrorOn('NewUsername')"
                    }
                  ],
                  staticClass: "field-validation-error",
                  attrs: {
                    "data-test-element":
                      "changeusername-newusername-validationerror"
                  }
                },
                [_vm._v(_vm._s(_vm.errors.first("NewUsername")))]
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "field-validation-error",
                staticStyle: { display: "none" },
                attrs: {
                  "data-test-element":
                    "changeusername-newusername-customvalidationerror",
                  id: "newusername-validationerror"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _c(
                  "span",
                  {
                    staticClass: "label",
                    attrs: {
                      "data-test-element":
                        "changeusername-label-confirmusername"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "identityProvider:changeUsername:confirmUsername",
                          null,
                          [_vm.$t("shared:fields:username")]
                        )
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "control-with-help-offset" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.model.confirmUsername,
                        expression: "model.confirmUsername"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|confirmed:NewUsername",
                        expression: "'required|confirmed:NewUsername'"
                      }
                    ],
                    staticClass: "control",
                    class: {
                      "input-validation-error": _vm.hasErrorOn(
                        "ConfirmUsername"
                      )
                    },
                    attrs: {
                      name: "ConfirmUsername",
                      "data-test-element": "changeusername-confirmusername",
                      "data-vv-as": _vm.$t(
                        "identityProvider:changeUsername:confirmUsername",
                        null,
                        [_vm.$t("shared:fields:username")]
                      ),
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.model.confirmUsername },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.model,
                          "confirmUsername",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasErrorOn("ConfirmUsername"),
                      expression: "hasErrorOn('ConfirmUsername')"
                    }
                  ],
                  staticClass: "field-validation-error",
                  attrs: {
                    "data-test-element":
                      "changeusername-confrimusername-validationerror"
                  }
                },
                [_vm._v(_vm._s(_vm.errors.first("ConfirmUsername")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-actions" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: {
                    type: "submit",
                    name: "Action:ChangeUsername",
                    "data-test-element": "changeusername-continuebutton",
                    disabled: _vm.disabled
                  }
                },
                [_vm._v(_vm._s(_vm.$t("shared:action:continue")))]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "button-secondary link-text-transform",
                  attrs: {
                    href: "authentication/logincancel",
                    "data-test-element": "changeusername-cancellink"
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.loginCancel.apply(null, arguments)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("shared:action:cancel")))]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bdc3dfa", { render: render, staticRenderFns: staticRenderFns })
  }
}